import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  change?: {
    value: string;
    positive: boolean;
  };
}

export function StatCard({ title, value, icon: Icon, description, change }: StatCardProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.02, y: -4 }}
      transition={{ duration: 0.2 }}
    >
      <Card className="relative overflow-hidden group">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <CardContent className="pt-6 relative">
          <div className="flex items-center justify-between space-y-1">
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
            <motion.div
              className="p-3 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg"
              whileHover={{ rotate: 5, scale: 1.1 }}
              transition={{ duration: 0.2 }}
            >
              <Icon className="h-5 w-5 text-primary" />
            </motion.div>
          </div>
          <div className="flex items-end justify-between mt-4">
            <div>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="text-3xl font-bold text-foreground"
              >
                {value}
              </motion.div>
              {description && (
                <p className="text-xs text-muted-foreground mt-1">{description}</p>
              )}
            </div>
            {change && change.value && (
              <div className={`text-sm font-semibold ${change.positive ? 'text-emerald-500' : 'text-red-500'}`}>
                {change.value}
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
